import {TranslateModel} from '../../core/_base/layout/models/translate.model';

export class MenuItemBulletListModel {
  id: number;
  menu_item_id: number;
  title: string;


  constructor(id = 0,
              menu_item_id = 0,
              title = '') {
    this.id = id;
    this.menu_item_id = menu_item_id;
    this.title = title;
  }
}
